var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3V7H17V3H19.007C19.555 3 20 3.445 20 3.993V20.007C19.9997 20.2703 19.895 20.5227 19.7089 20.7089C19.5227 20.895 19.2703 20.9997 19.007 21H2.993C2.72972 20.9997 2.4773 20.895 2.29114 20.7089C2.10497 20.5227 2.00026 20.2703 2 20.007V3.993C2 3.445 2.445 3 2.993 3H5ZM8 16H6V18H8V16ZM8 13H6V15H8V13ZM8 10H6V12H8V10ZM15 1V5H7V1H15Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/SurveyIcon.c640ac1a4adc9cb7120538cbe1fc35ec.svg";
export { ForwardRef as ReactComponent };